import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function BubbleChatIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M4.667 5.575H8M4.667 7.851H10m-3.544 3.9H10.8c1.12 0 1.68 0 2.108-.213.376-.187.682-.485.874-.852C14 10.27 14 9.723 14 8.631V5.12c0-1.093 0-1.639-.218-2.056a1.98 1.98 0 0 0-.874-.852C12.48 2 11.92 2 10.8 2H5.2c-1.12 0-1.68 0-2.108.213a1.98 1.98 0 0 0-.874.852C2 3.482 2 4.028 2 5.12v8.15c0 .346 0 .519.073.608.063.077.16.122.26.122.117 0 .256-.108.533-.325l1.59-1.24c.326-.254.488-.38.669-.47q.241-.12.508-.174c.199-.04.407-.04.823-.04" /></svg>
  );
}

export default BubbleChatIcon;
